import './App.css';
import Hero from './components/Hero';
import Home from './components/Home';

function App() {
  return (
      // <Home/>
      <Hero/>
  );
}

export default App;
